// @flow
import dayjs from "dayjs";

const validMonthlyTypes = ["STANDARD", "WEEKDAYS_ONLY"];

const removeInvalidFromDateString = (queryParams, valuesToUpdate) => {
  let containsUpdate = false;
  const updatedQueryParams = {
    ...queryParams
  };

  valuesToUpdate.forEach((item) => {
    const param = queryParams[item];

    if (
      item === "monthly_type" &&
      !!param &&
      validMonthlyTypes.includes(param) === false
    ) {
      containsUpdate = true;

      delete updatedQueryParams[item];
    }

    if (item in queryParams && item !== "monthly_type") {
      const isValid = dayjs(param).isValid();

      if (!isValid) {
        containsUpdate = true;
        delete updatedQueryParams[item];
      }
    }
  });
  return containsUpdate ? updatedQueryParams : false;
};

export default removeInvalidFromDateString;
